// extracted by mini-css-extract-plugin
export default {"price-div":"SellPrice_price-div__RZeH7","price-input":"SellPrice_price-input__GhJGV"};